import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const TABS = [
  { key: 'attributes', to: '/org/catalog-setup/attributes' },
  { key: 'productTypes', to: '/org/catalog-setup/product-types' },
  { key: 'sizeSets', to: '/org/catalog-setup/size-sets' },
  { key: 'customizations', to: '/org/catalog-setup/customizations' },
  { key: 'skuRules', to: '/org/catalog-setup/sku-rules' },
] as const;

/** Route links styled as line tabs; a tab stays active on its own detail routes. */
export function CatalogSetupTabs() {
  const { t } = useTranslation('dictionary');

  return (
    <nav aria-label={t('setup.tabs.label')} className="mb-6 max-w-full overflow-x-auto border-b">
      <div className="flex items-center gap-1">
        {TABS.map((tab) => (
          <Link
            key={tab.key}
            to={tab.to}
            activeOptions={{ includeSearch: false }}
            activeProps={{ 'aria-current': 'page' }}
            className="text-muted-foreground hover:text-foreground data-[status=active]:text-foreground after:bg-foreground focus-visible:ring-ring/50 relative inline-flex h-10 items-center rounded-t-md px-3 text-sm font-medium whitespace-nowrap transition-colors outline-none after:absolute after:inset-x-0 after:-bottom-px after:h-0.5 after:opacity-0 after:transition-opacity focus-visible:ring-[3px] data-[status=active]:after:opacity-100"
          >
            {t(`setup.tabs.${tab.key}`)}
          </Link>
        ))}
      </div>
    </nav>
  );
}
